/**
 * Anonymous per-tab session id (lives for the module's lifetime — i.e. until the
 * tab closes). 16 random hex chars: enough to group one session's events, NOT a
 * user identifier.
 */

let sessionId: string | null = null;

/** `bytes` random bytes as lowercase hex. Prefers `crypto.getRandomValues`. */
export function randomHex(bytes: number): string {
  const arr = new Uint8Array(bytes);
  if (typeof crypto !== "undefined" && typeof crypto.getRandomValues === "function") {
    crypto.getRandomValues(arr);
  } else {
    for (let i = 0; i < arr.length; i++) arr[i] = Math.floor(Math.random() * 256);
  }
  return Array.from(arr)
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

export function getSessionId(): string {
  if (!sessionId) sessionId = randomHex(8);
  return sessionId;
}

/** Test-only: forget the cached session id. */
export function resetSessionId(): void {
  sessionId = null;
}
